import { createAction } from 'redux-act';
//////////////////////////////////////////////////

export const setInitialState = createAction('setInitialState');
export const setValueToStore = createAction('setValueToStore');
export const openFleetProfile = createAction('openFleetProfile');
export const closeFleetProfile = createAction('closeFleetProfile');
export const openDriverProfile = createAction('openDriverProfile');
export const closeDriverProfile = createAction('closeDriverProfile');
export const getAssignInfoSuccess = createAction('getAssignInfoSuccess');
export const toggleDriverFuelCards = createAction('toggleDriverFuelCards');
export const toggleDriverCertificates = createAction('toggleDriverCertificates');
export const getDriverFuelCardsRequest = createAction('getDriverFuelCardsRequest');
export const getDriverFuelCardsSuccess = createAction('getDriverFuelCardsSuccess');
export const toggleDriverFuelCardRequest = createAction('toggleDriverFuelCardRequest');
export const toggleDriverFuelCardSuccess = createAction('toggleDriverFuelCardSuccess');
export const getDriverProfileInfoSuccess = createAction('getDriverProfileInfoSuccess');
export const getDriverProfileInfoRequest = createAction('getDriverProfileInfoRequest');
export const getDriverCertificatesRequest = createAction('getDriverCertificatesRequest');
export const getDriverCertificatesSuccess = createAction('getDriverCertificatesSuccess');
export const getDriverAvailabilityStatusRequest = createAction('getDriverProfileInfoRequest');
export const getDriverAvailabilityStatusSuccess = createAction('getDriverAvailabilityStatusSuccess');
// truck
export const getTruckProfileRequest = createAction('getTruckProfileRequest');
export const getTruckProfileSuccess = createAction('getTruckProfileSuccess');
export const getTruckDocumentListRequest = createAction('getTruckDocumentListRequest');
export const getTruckDocumentListSuccess = createAction('getTruckDocumentListSuccess');
export const getTruckLatestKnownLocationSuccess = createAction('getTruckLatestKnownLocationSuccess');
// trailer
export const getTrailerProfileRequest = createAction('getTrailerProfileRequest');
export const getTrailerProfileSuccess = createAction('getTrailerProfileSuccess');
export const getTrailerDocumentListRequest = createAction('getTrailerDocumentListRequest');
export const getTrailerDocumentListSuccess = createAction('getTrailerDocumentListSuccess');
export const getTrailerLatestKnownLocationSuccess = createAction('getTrailerLatestKnownLocationSuccess');
